import axiosInstance from '../services/axiosInstance';
import { envUrls, buildEnvironment } from './env';

// Uncomment this to test localhost
// envUrls.usersService = 'http://localhost:4067/users/';

export default class UserService {
  // This method is used for certain routes to re-check auth token validity and to make sure the user still exists in the database -- Called from beforeEach route guard in Vue router
  static async getUser(uid) {
    return axiosInstance
      .get(`${envUrls.usersService}${uid}`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      })
      .then((response) => response.data);
  }

  static async getUsers() {
    return axiosInstance
      .get(`${envUrls.usersService}`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      })
      .then((response) => response.data);
  }

  static async getOrgUsers(orgId, role) {
    return axiosInstance
      .get(`${envUrls.usersService}orgUsers/${orgId}/${role}`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      })
      .then((response) => response.data);
  }

  static async getOrgDetails(orgId) {
    return axiosInstance
      .get(`${envUrls.usersService}orgDetails/${orgId}`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      })
      .then((response) => response.data);
  }

  static async updateUser(uid, payload) {
    return axiosInstance
      .post(`${envUrls.usersService}${uid}/update`, payload, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      })
      .then((response) => response.data);
  }

  static async changePassword(uid, payload) {
    return axiosInstance
      .post(`${envUrls.usersService}${uid}/update/password`, payload, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      })
      .then((response) => response.data);
  }

  static async updateUserAsAdmin(uid, payload) {
    return axiosInstance
      .post(`${envUrls.usersService}${uid}/update/admin`, payload, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      })
      .then((response) => response.data);
  }

  static async deleteUser(uid) {
    return axiosInstance
      .post(`${envUrls.usersService}${uid}/delete`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      })
      .then((response) => response.data);
  }

  static async sendFeedback(payload) {
    return axiosInstance
      .post(`${envUrls.usersService}feedback/send`, payload, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      })
      .then((response) => response.data);
  }

  static async askAnAnalyst(payload) {
    return axiosInstance
      .post(`${envUrls.usersService}ask-an-analyst`, payload, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      })
      .then((response) => response.data);
  }

  static async requestUpgrade(payload) {
    return axiosInstance
      .post(`${envUrls.usersService}request-upgrade`, payload)
      .then((response) => response.data);
  }

  static async createUser(payload) {
    if (buildEnvironment === 'staging') {
      // This is running on the STAGING site -- add stagingSite flag to payload
      payload.stagingSite = true;
    }
    return axiosInstance
      .post(`${envUrls.usersService}`, payload, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      })
      .then((response) => response.data);
  }

  static async resendInvite(uid) {
    return axiosInstance
      .post(`${envUrls.usersService}${uid}/resend-invite`, {}, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      })
      .then((response) => response.data);
  }

  static async updateOrgName(orgId, name) {
    return axiosInstance
      .post(`${envUrls.usersService}orgDetails/${orgId}/update`, { name }, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      })
      .then((response) => response.data);
  }

  static async getOrgUnits() {
    return axiosInstance
      .get(`${envUrls.usersService}organizational-units`)
      .then((response) => response.data);
  }
}
